// The server can't decode iPhone HEICs (tiled grids) and won't take a ProRAW
// DNG. A Photo Library pick arrives as JPEG; one picked through Files arrives
// untouched, sometimes with no type at all, so the extension is checked too.
const UNREADABLE_TYPES = ['image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence', 'image/x-adobe-dng', 'image/dng'];
const UNREADABLE_EXTENSION = /\.(heic|heif|dng)$/i;

export function isUnreadablePhoto(file) {
  return UNREADABLE_TYPES.includes(file.type.toLowerCase()) || UNREADABLE_EXTENSION.test(file.name);
}
